module.exports = __webpack_public_path__ + "img/circleBg.766e0f84.png";